
import Loading from 'component/Loading'
import { useEffect, useState } from 'react'

import API, { ResourceNotFoundError } from 'service/api'

const AudioMessage = ({
  message
}) =>
{
  const [media, setMedia] = useState(message.media)

  useEffect(() =>
  {
    // update refresh target to the latest component
    message.setMedia = setMedia

    // call only if API is not yet fetched
    if (!message.initialized && !message.media)
    {
      // increment retry count
      message.initialized = true

      // fetch image
      API.getMessageMedia(message.wa_id, message.seq).then(async resp => {
        const objUrl = URL.createObjectURL(await resp.blob())
        message.media = objUrl

        // delay re-rendering if it is not ready
        if (!message.setMedia)
        {
          setTimeout(() => message.setMedia(objUrl), 1000)
        }
        else
        {
          message.setMedia(objUrl)
        }
        delete message.setMedia
      }).catch(error => {
        if (error instanceof ResourceNotFoundError)
        {
          setMedia('error')
          return
        }
        throw error
      })
    }
  }, [])

  return !media
    ? <div className="audio-message loading"><Loading /></div>
    : 'error' == media
    ? <div className="audio-message-error">無法載入音訊。</div>
    : (
      <div className="audio-message">
        <audio controls src={media} type={message.mime_type} />
      </div>
    )
}

export default AudioMessage
